export function formatEstimatedTime(minutes) {
  if (minutes == null) return null;
  if (minutes < 1) return 'less than a minute';
  if (minutes < 60) return `~${Math.round(minutes)} min`;
  const h = Math.floor(minutes / 60);
  const m = Math.round(minutes % 60);
  return m > 0 ? `~${h}h ${m}m` : `~${h}h`;
}

export function slugify(str) {
    str = str.toLowerCase();
    str = str.replace(/[^a-z0-9 -]/g, ''); // Remove special characters
    str = str.replace(/\s+/g, '-'); // Replace spaces with hyphens
    return str;
}

const RESERVED_PROJECT_NAMES = ['archive'];

export function isReservedProjectName(projectName) {
    return RESERVED_PROJECT_NAMES.includes(slugify(projectName || ''));
}
